import React from 'react';

const StatusBadge = ({ status }) => {
  const normalizeStatus = (rawStatus) => {
    if (typeof rawStatus === 'string') {
      return rawStatus;
    }
    if (typeof rawStatus === 'number') {
      return String(rawStatus);
    }
    if (Array.isArray(rawStatus)) {
      return rawStatus.filter(Boolean).join(', ');
    }
    if (rawStatus && typeof rawStatus === 'object' && rawStatus.toString) {
      return rawStatus.toString();
    }
    return '';
  };

  const getStatusStyle = (normalizedStatus) => {
    const statusLower = normalizedStatus.toLowerCase();
    
    if (statusLower.includes('overdue') || statusLower.includes('past due')) {
      return {
        backgroundColor: '#fee2e2',
        color: '#dc2626',
        border: '1px solid #fecaca'
      };
    }
    
    if (statusLower.includes('upcoming') || statusLower.includes('pending')) {
      return {
        backgroundColor: '#fef3c7',
        color: '#d97706',
        border: '1px solid #fed7aa'
      };
    }
    
    if (statusLower.includes('paid') || statusLower.includes('complete')) {
      return {
        backgroundColor: '#dcfce7',
        color: '#16a34a',
        border: '1px solid #bbf7d0'
      };
    }
    
    if (statusLower.includes('awaiting') || statusLower.includes('waiting')) {
      return {
        backgroundColor: '#dbeafe',
        color: '#2563eb',
        border: '1px solid #bfdbfe'
      };
    }
    
    return {
      backgroundColor: '#f1f5f9',
      color: '#64748b',
      border: '1px solid #e2e8f0'
    };
  };

  const normalizedStatus = normalizeStatus(status);
  const style = getStatusStyle(normalizedStatus);
  
  return (
    <span style={{
      ...style,
      padding: '0.25rem 0.75rem',
      borderRadius: '12px',
      fontSize: '0.75rem',
      fontWeight: '500',
      display: 'inline-block',
      textTransform: 'uppercase',
      letterSpacing: '0.025em',
      whiteSpace: 'nowrap'
    }}>
      {normalizedStatus || '-'}
    </span>
  );
};

export default StatusBadge;
